import * as React from 'react';

import { extractDurationAndUnit } from 'components/common/TimeUnitInput';
import { TIME_UNITS } from 'components/event-definitions/event-definition-types/FilterForm';
import { describeExpression } from 'util/CronUtils';

const AssetEventSummary = ({ config }) => {
  const {
    search_within_ms: searchWithinMs,
    execute_every_ms: executeEveryMs,
    use_cron_scheduling: useCronScheduling,
    cron_expression: cronExpression,
    cron_timezone: cronTimezone,
    _is_scheduled: isScheduled,
    config: subTypeConfig,
  } = config;

  const subtypeToName = {
    'risk_score_threshold': 'Risk Score Threshold',
  };

  const searchWithin = extractDurationAndUnit(searchWithinMs, TIME_UNITS);
  const executeEvery = extractDurationAndUnit(executeEveryMs, TIME_UNITS);

  const renderCronExpression = (expression: string) => {
    if (expression) {
      return describeExpression(expression);
    }

    return 'Error: no cron expression specified!';
  };

  return (
    <dl>
      <dt>Type</dt>
      <dd>Asset Event - {subtypeToName[subTypeConfig.type]}</dd>

      {subTypeConfig.type !== 'risk_score_threshold' && (
        <>
          <dt>Search within</dt>
          <dd>
            {searchWithin.duration} {searchWithin.unit.toLowerCase()}
          </dd>
        </>
      )}
      <dt>Use Cron Scheduling</dt>
      <dd>{useCronScheduling ? 'yes' : 'no'}</dd>
      {useCronScheduling ? (
        <>
          <dt>Cron Expression</dt>
          <dd>{cronExpression}</dd>
          <dt>Cron Description</dt>
          <dd>{renderCronExpression(cronExpression)}</dd>
          <dt>Time Zone</dt>
          <dd>{cronTimezone}</dd>
        </>
      ) : (
        <>
          <dt>Execute search every</dt>
          <dd>
            {executeEvery.duration} {executeEvery.unit.toLowerCase()}
          </dd>
        </>
      )}
      <dt>Enable scheduling</dt>
      <dd>{isScheduled ? 'yes' : 'no'}</dd>
      <dt>Skip Events on First Run</dt>
      <dd>{subTypeConfig.skip_first_run ? 'yes' : 'no'}</dd>
      <dt>Risk Score Threshold</dt>
      <dd>{subTypeConfig.threshold}</dd>
    </dl>
  );
};

export default AssetEventSummary;
